import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../services/dashboard/data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class HeaderComponent implements OnInit {
  @Output() currentPageChange: EventEmitter<string> = new EventEmitter<string>();
@Output() isUserInDashboard: EventEmitter<void> = new EventEmitter<void>();

  currentPage: string = '';
  nameFarmaco: string | undefined;
  companyId: number | null = null;
  isRegional: boolean = false;
  makeItVisible:boolean=false;

  private subscriptions = new Subscription();

  constructor (
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dataService: DataService
  ) { }

  ngOnInit (): void {
    // Subscribe to navigation changes to update page name and medicine name
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkRegionalRoute();
      this.setCurrentPage(this.activatedRoute.root);
    //  this.loadMedicineName();

    });

    this.subscriptions.add(
      this.dataService.getBusinessName().subscribe(businessName => {
        this.nameFarmaco = businessName;
      })
    );

  //  this.nameFarmaco = localStorage.getItem('medicineName') || '';



    // Initial load
    this.checkRegionalRoute();
    this.setCurrentPage(this.activatedRoute.root);
    //this.loadMedicineName();
  }

  ngOnDestroy (): void {
    this.subscriptions.unsubscribe();
  }



private checkRegionalRoute() {
  // Controlla sia il vecchio che il nuovo percorso
  this.isRegional = this.router.url.includes('/dashboard/territorial/regional')
}
/** We don't use this anymore since we created a subscription to the dataService for the medicine name */
 private loadMedicineName () {
  const companyIdString = sessionStorage.getItem('companyId');
  this.companyId = companyIdString ? parseInt(companyIdString, 10) : null;
  this.dataService.actualCompanyId = this.companyId;

  const storedMedicineId = sessionStorage.getItem('medicineId');
  const medicineId = this.dataService.actualMedicineId || (storedMedicineId ? parseInt(storedMedicineId, 10) : null);

  if (this.companyId !== null && medicineId !== null) {
    this.dataService.getMedicinesByCompanyId(this.companyId).subscribe({
      next: medicines => {
        const medicine = medicines.find(m => m.id === medicineId);
        this.nameFarmaco = medicine?.businessName;
        if (medicine) {
          this.dataService.setBusinessName(medicine.businessName);
        }
      },
      error: err => {
        console.error('Errore nel caricamento:', err);
      }
    });
  }
}


private setCurrentPage(route: ActivatedRoute) {
  const children: ActivatedRoute[] = route.children;
  if (children.length === 0) return;

  for (const child of children) {
    const segments = child.snapshot.url.map(segment => segment.path);
    
    if (segments.length > 0) {
      // look for the first segment
      for (let i = segments.length - 1; i >= 0; i--) {
        if (!/^\d+$/.test(segments[i]) && segments[i] !== 'territorial') {
          this.currentPage = segments[i];
          break;
        }
      }

     
      if (this.currentPage === "farmaco") {
        this.currentPage = "Farmaci";
        this.makeItVisible = false;
      } else if (this.currentPage === "profile") {
        this.currentPage = "Profilo";
        this.makeItVisible = false;
      } else if (this.currentPage === "national") {
        this.currentPage = "Nazione";
        this.makeItVisible = true;
      } else if (this.currentPage === "regional") {
        this.currentPage = "Regione";
        this.makeItVisible = true;
      } else if (this.currentPage === "home") {
        this.currentPage = "Home";
        this.makeItVisible = false;
      }

      this.currentPageChange.emit(this.currentPage);
    }

    this.setCurrentPage(child); // CHECK CHILD ROUTES FOR NESTED PATHS
  }
}


  navigateToFarmaco () {
     this.isUserInDashboard.emit();
    this.router.navigate(['/dashboard/territorial/farmaco']);
  }
}